import { useMutation } from '@tanstack/react-query';
import ApiError from 'src/api/errorHandling/ApiError';
import { acceptSupervisorInvitation } from 'src/api/invitationAPI';

export default function useAcceptSupervisorInvitation() {
  return useMutation<void, ApiError, { verificationGuid: string, name?: string, email?: string, phoneNumber?: string }>({
    mutationFn: ({ verificationGuid, name, email, phoneNumber }) => acceptSupervisorInvitation(verificationGuid, name, email, phoneNumber),
  });
}
